import {
  Component,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from "@angular/core";
import { AppService } from "src/app/app.service";
import { ReportingPagesDataService } from "../reporting-pages-data.service";
import {
  VAIconRegistryService,
  closeCircle,
  fileExcel,
  search,
  sync,
} from "@va/core-library/icons";

@Component({
  selector: "app-global-reporting-filters",
  templateUrl: "./global-reporting-filters.component.html",
  styleUrls: ["./global-reporting-filters.component.scss"],
  host: { class: "reporting-filter-component" },
})
export class GlobalReportingFiltersComponent {
  @Input() modelOnlyComp: {
    show: boolean;
    value: boolean;
  };
  @Input() isSearchFilter: boolean;
  @Input() exportColumns: Array<any>;
  @Input() exportKey: string;
  @Input() gridUrl: string;
  @Input() defaultSearch: string;
  @Output() isFilterValueChange = new EventEmitter();
  @Output() onGlobalFilterChange = new EventEmitter();
  @Output() onReloadGrid = new EventEmitter();
  @Output() onModelCompanyValueChange = new EventEmitter();
  showFilterValue: boolean;
  modelCompanyValue: boolean;
  showModelOnlyComp: boolean;
  showExport: boolean;
  queryField;
  searchValue;
  pageName;
  constructor(
    private dataService: ReportingPagesDataService,
    private appService: AppService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.showFilterValue = false;
    this.showModelOnlyComp = false;
    this.modelCompanyValue = false;
    this.iconRegistry.registerIcons([search, fileExcel, sync, closeCircle]);
  }
  ngOnInit() {
    this.searchValue = this.searchValue === void 0 ? "" : this.searchValue;
    this.queryField = "";
    if (this.searchValue !== "") {
      this.onGlobalFilterChange.emit(this.searchValue);
    }
    this.pageName = `${(
      location.pathname.split("/")[2] || ""
    ).toUpperCase()}_PAGE`;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.gridUrl && changes.gridUrl.currentValue !== undefined) {
      this.showFilterValue = false;
      this.searchValue = "";
      this.queryField = "";
    }
    if (
      changes.defaultSearch &&
      changes.defaultSearch.currentValue !== undefined
    ) {
      this.searchValue = changes.defaultSearch.currentValue;
    }
    if (changes.exportKey && changes.exportKey.currentValue !== undefined) {
      this.showExport = changes.exportKey.currentValue !== "";
    }
    if (
      changes.modelOnlyComp &&
      changes.modelOnlyComp.currentValue !== undefined
    ) {
      this.modelCompanyValue = changes.modelOnlyComp.currentValue.value;
      this.showModelOnlyComp = changes.modelOnlyComp.currentValue.show;
    }
  }

  onSearch() {
    this.onGlobalFilterChange.emit(this.searchValue);
  }

  exportToExcel() {
    const exportObj = {
      columns: this.exportColumns,
      key: this.exportKey,
    };
    const extras = {
      UTCTIME: new Date().toUTCString(),
      URL: location.href,
      VALUE: this.pageName,
    };

    this.appService.logUserAction(
      {},
      "",
      "",
      "EXPORT_ONFILTER",
      extras,
      "",
      "",
    );
    this.dataService.createExcelDownloadUsingHiddenForms(exportObj);
  }

  toggleFilter(e) {
    const extras = {
      UTCTIME: new Date().toUTCString(),
      URL: location.href,
      VALUE: this.pageName,
    };

    this.appService.logUserAction(
      {},
      "",
      "",
      "TOGGLE_ONFILTER",
      extras,
      "",
      "",
    );
    this.isFilterValueChange.emit({ showFilters: e });
  }

  onReload() {
    const extras = {
      UTCTIME: new Date().toUTCString(),
      URL: location.href,
      VALUE: this.pageName,
    };

    this.appService.logUserAction(
      {},
      "",
      "",
      "RELOAD_ONFILTER",
      extras,
      "",
      "",
    );
    if (this.pageName === "ALLCOMPANY_PAGE") {
      this.searchValue = "";
    } else {
      this.clearSearch();
    }
    this.onReloadGrid.emit();
  }

  clearSearch() {
    this.searchValue = "";
    this.onGlobalFilterChange.emit(this.searchValue);
  }
  modelCompanyChange(e) {
    this.onModelCompanyValueChange.emit({ modelCompanyValue: e });
  }
}
